import _regenerator from "/usr/app/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/usr/app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import fetcher from "../../common/axiosInstance";
import { awaitTimeout } from "@/utils/GlobalJavascriptFunction";
import { SEARCH_LAB_ENABLED } from "@globalConfig";
import { searchLab__byPostIds } from "@/apis/searchLab/searchLab";
export var api__getRecentlyViewedPostsData = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(listOfIdTime, size) {
    var params, cacheKey, result, _listOfIdTime$map, postIds, products, res;
    return _regenerator().w(function (_context) {
      while (1) switch (_context.n) {
        case 0:
          // @FIXME Suhaib add TypeScript types for the response data
          // Construct the params object
          params = {
            posts: listOfIdTime
          };
          cacheKey = JSON.stringify(listOfIdTime === null || listOfIdTime === void 0 ? void 0 : listOfIdTime.map(function (item) {
            return item.post_id;
          }));
          window.__FIXME_BLOCK_PROMISE_2 = window.__FIXME_BLOCK_PROMISE_2 || {};
          window.__FIXME_CACHE_API_2 = window.__FIXME_CACHE_API_2 || {};
          if (!window.__FIXME_BLOCK_PROMISE_2[cacheKey]) {
            _context.n = 1;
            break;
          }
          _context.n = 1;
          return awaitTimeout(2000);
        case 1:
          if (!window.__FIXME_CACHE_API_2[cacheKey]) {
            _context.n = 2;
            break;
          }
          return _context.a(2, window.__FIXME_CACHE_API_2[cacheKey]);
        case 2:
          window.__FIXME_BLOCK_PROMISE_2[cacheKey] = true;

          // RecentlyViewedContext reads `res.data` off the return value and stores it
          // as `carsData`, which it then `.map`s — so the returned object's `.data`
          // MUST be a plain products array.
          if (!SEARCH_LAB_ENABLED) {
            _context.n = 4;
            break;
          }
          // search-lab takes { post_ids, size } and returns ordered product cards;
          // wrap them so the returned `.data` stays the products array.
          postIds = (_listOfIdTime$map = listOfIdTime === null || listOfIdTime === void 0 ? void 0 : listOfIdTime.map(function (item) {
            return item.post_id;
          })) !== null && _listOfIdTime$map !== void 0 ? _listOfIdTime$map : [];
          _context.n = 3;
          return searchLab__byPostIds(null, postIds, size);
        case 3:
          products = _context.v;
          result = {
            data: products
          };
          _context.n = 6;
          break;
        case 4:
          _context.n = 5;
          return fetcher(null, true).post("/search/by-post-ids?size=" + size, params);
        case 5:
          res = _context.v;
          result = res.data;
        case 6:
          window.__FIXME_CACHE_API_2[cacheKey] = result;
          window.__FIXME_BLOCK_PROMISE_2[cacheKey] = undefined;
          // Return value whose `.data` is the products array (legacy contract).
          return _context.a(2, result);
      }
    }, _callee);
  }));
  return function api__getRecentlyViewedPostsData(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();